









import Vue, {PropType} from 'vue';
import {SelectorOption} from '@/lib/types';

export default Vue.extend({
    data() {
        return {
            offset: 0,
            displayAmount: 6,
            selectedOption: {} as SelectorOption,
        };
    },
    props: {
        options: {
            type: Array as PropType<SelectorOption[]>,
        },
    },
    methods: {
        selectOption(selection: SelectorOption) {
            this.selectedOption = selection;
            this.$emit('optionSelected', this.selectedOption);
        },
        controlOffset(delta: number) {
            this.offset += delta;
        },
    },
    computed: {
        offsetOptions() {
            const self: any = this;
            return this.options.slice(self.offset, self.offset + self.displayAmount);
        },
    },
});
